import {
  CONTACT_LOADING,
  GET_CONTACT,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_FAIL,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_FAIL,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAIL,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAIL,
  CONTACT_RESET,
} from "./actionType";

const INIT_STATE = {
  contacts: [],
  error: {},
};

const Contact = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CONTACT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CONTACT:
          return {
            ...state,
            contacts: action.payload.data,
            isContactCreated: false,
            isContactSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CONTACT_FAIL:
      switch (action.payload.actionType) {
        case GET_CONTACT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isContactCreated: false,
            isContactSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CONTACT: {
      return {
        ...state,
        isContactCreated: false,
        loading: true,
      };
    }

    case CONTACT_LOADING: {
      return {
        ...state,
        isContactCreated: false,
        loading: true,
      };
    }

    case ADD_CONTACT_SUCCESS:
      return {
        ...state,
        isContactCreated: true,
        loading: false,
        contacts: [action.payload.data, ...state.contacts],
      };

    case ADD_CONTACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        isContactCreated: true,
        contacts: state.contacts.filter(
          (contact) => contact.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CONTACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        isContactCreated: true,
        contacts: state.contacts.map((contact) =>
          contact.id.toString() === action.payload.data.id.toString()
            ? { ...contact, ...action.payload.data }
            : contact
        ),
      };

    case UPDATE_CONTACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CONTACT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Contact;
